module.exports = __webpack_public_path__ + "img/MetaMaskLogo.5f70bc93.svg";